import {EntityApiService} from '@dofleini/security';

import {authentication} from '@/settings';

class CauseApiService extends EntityApiService {


}

export default new CauseApiService(`${authentication.path}/api/causes`);
